(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-serum-stats"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('londella-percentages')) {
  customElements.define('londella-percentages', class extends HTMLElement {
    connectedCallback() {
      if (this.started || this.observer) return;
      this.nodes = Array.from(this.querySelectorAll('[data-ldp-count]'));
      if (!this.nodes.length) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) { this.started = true; return; }
      this.nodes.forEach(node => { node.textContent = '0'; });
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.started = true;
        this.observer.disconnect();
        this.observer = null;
        const start = performance.now();
        const tick = now => {
          const progress = Math.min(1, Math.max(0, (now - start) / 1100));
          const eased = 1 - Math.pow(1 - progress, 3);
          this.nodes.forEach(node => {
            const target = Number(node.dataset.ldpCount);
            node.textContent = progress === 1 ? String(target).replace('.', ',') : String(Math.floor(target * eased));
          });
          if (progress < 1) this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }, { threshold: 0.15 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) { this.observer.disconnect(); this.observer = null; }
      if (this.frame) cancelAnimationFrame(this.frame);
      if (this.started && this.nodes) this.nodes.forEach(node => { node.textContent = node.dataset.ldpCount.replace('.', ','); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-serum-voices"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('londella-voices')) {
customElements.define('londella-voices',class extends HTMLElement {
connectedCallback(){
if(this.cleanup)return;
const track=this.querySelector('.ldr-track'),prev=this.querySelector('[data-ldr-prev]'),next=this.querySelector('[data-ldr-next]'),bar=this.querySelector('.ldr-progress span');
const update=()=>{const max=track.scrollWidth-track.clientWidth;prev.disabled=track.scrollLeft<=2;next.disabled=max<2||track.scrollLeft>=max-2;bar.style.width=max<=0?'100%':Math.max(8,(track.scrollLeft+track.clientWidth)/track.scrollWidth*100)+'%';};
const move=direction=>{const card=track.querySelector('.ldr-card');if(!card)return;track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
const back=()=>move(-1),forward=()=>move(1);
prev.addEventListener('click',back);next.addEventListener('click',forward);track.addEventListener('scroll',update,{passive:true});
const resize=new ResizeObserver(update);resize.observe(track);update();
this.cleanup=()=>{prev.removeEventListener('click',back);next.removeEventListener('click',forward);track.removeEventListener('scroll',update);resize.disconnect();};
}
disconnectedCallback(){if(this.cleanup){this.cleanup();this.cleanup=null;}}
});
}

  } catch(e) { console.error(e); }
})();
})();
